(function() {
'use strict';

/*
    this is a horrible hack to make sure that all the services
    that we need to be constructed and listening for events are
    alive and ready
*/
angular
    .module('TR')
    .service('bootstrapper', bootstrapper);

function bootstrapper($injector) {
    const service = {
        init
    };

    function init() {
        $injector.get('hotelService');
        $injector.get('flightSearch');
        $injector.get('hotelSearch');
        $injector.get('transferSearch');
        $injector.get('authService');
        $injector.get('searchUnitService');
        $injector.get('basketService');
        $injector.get('urgencyMessaging');
    }

    return service;
}
})();
